(() => {
  'use strict';
  if (window.famStorefrontReady) return;
  window.famStorefrontReady = true;
  const menu = document.querySelector('.fam-store-menu');
  const nav = document.querySelector('.fam-store-nav');
  function closeMenu() {
    if (!menu || !nav) return;
    nav.removeAttribute('data-open');
    menu.setAttribute('aria-expanded','false');
    menu.setAttribute('aria-label','Open menu');
  }
  menu?.addEventListener('click', () => {
    const open = menu.getAttribute('aria-expanded') !== 'true';
    nav.toggleAttribute('data-open',open);
    menu.setAttribute('aria-expanded',String(open));
    menu.setAttribute('aria-label',open ? 'Close menu' : 'Open menu');
  });
  document.addEventListener('keydown',event => {
    if (event.key === 'Escape' && menu?.getAttribute('aria-expanded') === 'true') { closeMenu(); menu.focus(); }
  });
  nav?.addEventListener('click',event => { if (event.target.closest('a')) closeMenu(); });
  document.addEventListener('click',async event => {
    const filter = event.target.closest('[data-fam-category]');
    if (filter) {
      const container = filter.closest('.fam-store-home');
      if (!container) return;
      event.preventDefault();
      const category = filter.dataset.famCategory;
      container.querySelectorAll('[data-fam-category]').forEach(link => link.setAttribute('aria-current',String(link === filter)));
      container.querySelectorAll('[data-fam-category-item]').forEach(card => { card.hidden = category !== 'all' && card.dataset.famCategoryItem !== category; });
      container.querySelector('#shop')?.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
      return;
    }
    const button = event.target.closest('[data-fam-quick-add],[data-fam-bundle-add]');
    if (!button || button.disabled) return;
    const feedback = button.closest('.fam-store-home')?.querySelector('[data-fam-store-feedback]');
    if (!window.FastAsleepCart) { if(feedback) feedback.textContent='The cart is still loading. Please try again.'; return; }
    const ids = (button.dataset.famBundleAdd || button.dataset.famQuickAdd).split(',').map(Number);
    if (ids.some(id => !Number.isSafeInteger(id) || id <= 0)) { if(feedback) feedback.textContent='This selection is unavailable. Please open the product to choose an option.'; return; }
    button.disabled = true;
    button.setAttribute('aria-busy','true');
    if(feedback) feedback.textContent='';
    try {
      await window.FastAsleepCart.add(ids.map(id => ({id,quantity:1})));
      window.FastAsleepCart.open(button,{refresh:false});
    } catch(error) {
      if(feedback) { feedback.textContent=error.message || 'Unable to add this item. Please try again.'; feedback.scrollIntoView({block:'nearest'}); }
    } finally { button.disabled=false; button.removeAttribute('aria-busy'); }
  });
  if (document.body.hasAttribute('data-fam-preview')) {
    document.addEventListener('submit',event => {
      if (event.submitter?.hasAttribute('data-fam-checkout')) {
        event.preventDefault();
        const status = document.querySelector('[data-fam-cart-status]');
        if (status) status.textContent='This is a local preview. Checkout is disabled and no order has been placed.';
      }
    },true);
    if (new URLSearchParams(location.search).has('cart')) window.FastAsleepCart?.open();
  }
  window.FastAsleepCart?.refresh().catch(() => {});
})();
